import { combineEpics } from 'redux-observable';
import { fromLocation } from './from-location';
import { fromState } from './from-state';
import { searchEpic, fetchSearchResultsEpic, fetchKbSearchResultsEpic } from './search';

export default combineEpics(fromState, fromLocation, searchEpic, fetchSearchResultsEpic, fetchKbSearchResultsEpic);
